import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';
class AircraftsMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      data_comparison: [],
      range: 1,
      date: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.StyleFormat = this.StyleFormat.bind(this);
    this.search = this.search.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date: this.state.date,
      type: 'month',
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/movimentacao/aeronaves/mensal', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.main, data_comparison: responseJson.data.comparison, titles: responseJson.data.titles});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  StyleFormat (cell, row, props) {
    var format = cell;
    var self = this;
    if(typeof self.state.data_comparison[row['registration']][props] !== 'undefined') {
      var label = 'label label-' + self.state.data_comparison[row['registration']][props];
      format = (
        <span className={label}>{cell}</span>
      );
    }

    return format;
  }


  render() {
    var self = this;

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Aeronaves.ControleMensalDeMovimentacao.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Aeronaves.ControleMensalDeMovimentacao.formulario.MesAno}:</label>
            <InputMask value={this.state.date}  maskChar={null} name="date " mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" required />
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
          </div>
        </div>
      </form>
      <hr/>
      {
        (typeof this.state.titles !== 'undefined') ?
          <BootstrapTable data={this.state.data} exportCSV={true} pagination={true} striped={true} hover={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Aeronaves.ControleMensalDeMovimentacao.semColaboradores}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
              {Object.keys(self.state.titles).map(function(t) {
                var data = self.state.titles[t];
                if (t > 0) {
                  return (
                    <TableHeaderColumn dataField={data.field} dataFormat={self.StyleFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: self.locale.general.procurar}} formatExtraData={data.field} width='280'>{data.title}</TableHeaderColumn>
                  );
                } else {
                  return (
                    <TableHeaderColumn isKey={true} dataField={data.field} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: self.locale.general.procurar}} width='280'>{data.title}</TableHeaderColumn>
                  );
                }
              })}
          </BootstrapTable>
        :
        ''
      }
    </div>
  </div>
</div>
    );
  }
}

export default AircraftsMonth;


// WEBPACK FOOTER //
// ./src/Components/Aircrafts/AircraftsMonth.js